import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../Actions/Modal';

import './../loader.css';

class LoaderContainer extends Component {
    render() {
        return (
            <>
                {
                    this.props.open &&
                    <div className="modal-back">
                        <div className="loader-container">
                            <div className="image-container">
                                {/* <img src={LogoAlcaldia} alt="Alcaldia"></img> */}
                            </div>
                            <div className="bars-container">
                                <div className="black-bar"></div>
                                <div className="loader-bar move-first"></div>
                                <div className="loader-bar move-second"></div>
                                <div className="loader-bar move-third"></div>
                                <div className="loader-bar move-fourth"></div>
                                <div className="loader-bar move-fiveth"></div>
                                <div className="black-bar"></div>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}

function mapStateToProps(state, props) {
    // console.log(state);
    return {
        open: state.modal.openLoader,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(LoaderContainer);